// EC-27 : Sub Task - 553 Cart Page 
// Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments.
import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

addToListModalStyles.listsSelect = {
	cssOverrides: {
		formField: css`
			margin-top: 15px;
			label{
				font-weight: 600;
			}
		`, 
	},
}

addToListModalStyles.newListInput = {
	cssOverrides: {
		formField: css`
			margin-top: 15px;
			label{
				font-weight: 600;
			}
		`, 
	},
}

// EC-27 : Sub Task - 553 Cart Page 
// End: Refactored dynamic CSS from CMS to code for consistent behavior across environments.